import { render, staticRenderFns } from "./warn_category_list.vue?vue&type=template&id=a74ede62&scoped=true"
import script from "./warn_category_list.vue?vue&type=script&lang=ts"
export * from "./warn_category_list.vue?vue&type=script&lang=ts"
import style0 from "./warn_category_list.vue?vue&type=style&index=0&id=a74ede62&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a74ede62",
  null
  
)

export default component.exports